import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#ffffff',
      padding: '4px',
      color: '#3f3f46',
      maxWidth: '412px',
      border: '1px solid #e4e4e7',
      fontSize: '12px',
      fontFamily: 'Inter-Regular',
      boxSizing: 'border-box',
      boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
      borderRadius: '4px'
    },
  }))(Tooltip);

const InfoTooltip = props => {

    return (
        <HtmlTooltip
            title={
                <div style={{padding: '12px', display: 'flex', flexDirection: 'column'}}>
                    <label style={{fontFamily:'Inter-Regular',fontSize:'14px',color:'#27272A',marginBottom:'12px'}}>{"For more information about capacity planning please reference the Highway Capacity Manual (2017)."}</label>
                    <div style={{display: 'flex', flexDirection:'row'}}> <div style={{width:'12px',height:'12px',background: '#DBEAFE',marginRight:'8px'}}></div> <label style={{fontFamily:'Inter-Regular',fontSize:'14px',color:'#52525B'}}>{"Light blue means the field is editable"}</label></div>
                </div>
            }
        >
                <img src={require('../../../assets/icons/info.svg')} />
        </HtmlTooltip>
    )
}

export default InfoTooltip;